'use client';

import { ReactElement, ReactNode } from 'react';
import { useMobileNav } from 'contexts/MobileNavContext';

export default function MainContent({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const { isMobileNavOpen } = useMobileNav();

  return (
    <div id="main-content" tabIndex={-1} inert={isMobileNavOpen}>
      {children}
    </div>
  );
}
